import { Injectable } from '@angular/core';
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  Auth,
  UserCredential
} from 'firebase/auth';
import {
  getDatabase,
  ref,
  set,
  Database
} from 'firebase/database';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private auth: Auth;
  private db: Database;

  constructor() {
    this.auth = getAuth();           // Get default Firebase Auth instance
    this.db = getDatabase();         // Get default Firebase Realtime DB instance
  }

  /** Sign up a new user and persist profile to Firebase Realtime Database */
  async signUp(
    email: string,
    password: string,
    firstName: string,
    lastName: string,
    country: string
  ): Promise<UserCredential> {
    const userCredential = await createUserWithEmailAndPassword(this.auth, email, password);
    const user = userCredential.user;

    // Store user profile in Realtime Database
    await set(ref(this.db, `users/${user.uid}`), {
      uid: user.uid,
      firstName: firstName,
      lastName: lastName,
      email: user.email,
      country: country
    });

    return userCredential;
  }

  /** Sign in a user with email and password */
  signIn(email: string, password: string): Promise<UserCredential> {
    return signInWithEmailAndPassword(this.auth, email, password);
  }

  /** Send a password reset email */
  resetPassword(email: string): Promise<void> {
    return sendPasswordResetEmail(this.auth, email);
  }

  /** Sign out the current user */
  signOut(): Promise<void> {
    return this.auth.signOut();
  }
}
